import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'unistore/preact';
import { actions } from 'actions';
import RadioQuestionOption from 'components/questions/RadioQuestionOption';


const FeedbackQuestion = ({ labelId, question, setSelectedOptionId, isDisabled }) => {
  const { id, options, text } = question;

  const changeFeedbackOption = (option) => setSelectedOptionId(option.id);

  const getOptions = () => {
    return options && options.map((optionDetail, index) => {
      const rdoName = `csw-q-rdo-${id}`;
      const rdoKey = `${rdoName}-${optionDetail.id}-${index}`;

      return (
         <RadioQuestionOption key={rdoKey}
                              i={index}
                              radioName={rdoName}
                              option={optionDetail}
                              onRadioSelected={()=> changeFeedbackOption(optionDetail)}
                              isEmoji={false}
                              isImage={false}
                              isDisabled={isDisabled}/>
      );
    }) || [];
  };

  return (
    <fieldset className="csw-fieldset">
      <legend className="sr-only" aria-hidden={true}>{text}</legend>
      <ul className="csw-option-list font-default"
          aria-labelledby={labelId}
          role="radiogroup">
        {getOptions()}
      </ul>
    </fieldset>
  );
};

FeedbackQuestion.propTypes /* remove-proptypes */ = {
  labelId: PropTypes.string.isRequired,
  question: PropTypes.object.isRequired,
  setSelectedOptionId: PropTypes.func,
  isDisabled: PropTypes.bool
};

export default connect('', actions)(FeedbackQuestion);
